import { Component } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { nav_path } from 'src/app/app-routing.module';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConsoleLoggerService } from 'src/app/core/services/console-logger.service';
import { SeoService } from '../../../../core/services/seo.service';

@Component({
  selector: 'anon-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent {
  public signupForm = new FormGroup({
    email: new FormControl<string>(
      '',
      {nonNullable: true, validators: [Validators.required, Validators.email]}
    ),
    password: new FormControl<string>(
      '',
      {nonNullable: true, validators: [Validators.required, Validators.minLength(8)]})
  });
  public readonly nav_path = nav_path;
  private title = "Sign-up page";

  constructor(
    public authService: AuthService,
    private fb: UntypedFormBuilder,
    private cLog: ConsoleLoggerService,
    private seo: SeoService
  ) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.signUp
    });
  }

  public get email() { return this.signupForm.controls.email; }
  public get password() { return this.signupForm.controls.password; }

  public onSubmit() {
    this.authService.signUp(this.email.value, this.password.value)
      .then(() => this.cLog.info('Welcome, hope you enjoy 🎉') );
  }
}
